const cssClassPrefix = 'profile-details-toolbar'
export const classes = {
  container: `${cssClassPrefix}-container`,
}
